import {
    EnvironmentProviders,
    Provider,
    inject,
    provideEnvironmentInitializer,
} from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from 'environments/environment';
import { PwaInstallService } from './pwa-install.service';
import { PwaUpdateService } from './pwa-update.service';

export const providePwa = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.serviceWorker,
            // Registering only once the app is stable keeps the service worker from competing with
            // the first paint for bandwidth; the timeout covers the case where the app never
            // reports stability because of a long lived subscription.
            registrationStrategy: 'registerWhenStable:30000',
        }),
        provideEnvironmentInitializer(() => {
            inject(PwaUpdateService).init();

            // Instantiated eagerly: `beforeinstallprompt` fires early and is only delivered once, so
            // the listener has to be in place before any component asks for it.
            inject(PwaInstallService);
        }),
    ];
};
